import React, { useState } from 'react';
import { Box, Paper, Tab, Tabs } from '@mui/material';
import { theme as colorTheme } from '../../../Convoze.theme';
import ElevenLabsSyncPanel from './ElevenLabsSyncPanel';
import NipponBotInteractionsTable from './NipponBotInteractionsTable';
import NipponBotMisReport from './NipponBotMisReport';

const primary = colorTheme('palette', 'primary').value;

export default function CallsTab({ onMessage, onRefresh }) {
  const [activeTab, setActiveTab] = useState('calls');

  return (
    <Box sx={{ display: 'grid', gap: 3 }}>
      <Paper
        sx={{
          boxShadow: 0,
          border: 1,
          borderColor: 'grey.200',
          borderRadius: 2,
          overflow: 'hidden',
          px: 2,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 2,
          flexWrap: 'wrap',
          '& .MuiTabs-indicator': { backgroundColor: primary, height: 3 },
          '& .MuiTab-root': {
            minHeight: 48,
            py: 1,
            fontSize: '0.875rem',
            textTransform: 'none',
            color: 'grey.600',
            '&.Mui-selected': { color: primary },
            '&:hover': { backgroundColor: `${primary}14` },
          },
          '& .MuiTouchRipple-root': { color: primary },
        }}
      >
        <Tabs value={activeTab} onChange={(event, value) => setActiveTab(value)} textColor="inherit">
          <Tab value="calls" label="Calls" />
          <Tab value="mis" label="MIS Report" />
        </Tabs>
        <ElevenLabsSyncPanel onComplete={onRefresh} onMessage={onMessage} />
      </Paper>
      {activeTab === 'mis' ? (
        <NipponBotMisReport onMessage={onMessage} />
      ) : (
        <NipponBotInteractionsTable
          recordingPlayerMode="dialog"
          showManualUpload
          hideExport
          onMessage={onMessage}
          onUploadComplete={onRefresh}
        />
      )}
    </Box>
  );
}
